package kz.dentalcrm.app.screens.service_categories.list.mvi

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

@Immutable
data class ServiceCategoriesViewState(
    val categories: PersistentList<ServiceCategory> = persistentListOf(),
    val search: String = "",
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
    }
}
